import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Microsoft365UserLicenses } from '../models/generated/ziroModels';

@Injectable()
export class Microsoft365LicensesContext {
  private _http = inject(HttpClient);

  private _stateSource = new ReplaySubject<Microsoft365UserLicenses>(1);
  state$ = this._stateSource.asObservable();

  updateUserLicenses(
    tenantId: string,
    userPrincipalName: string,
    microsoft365UserLicenses: Microsoft365UserLicenses,
  ): Observable<void> {
    return this._http
      .put<void>(
        `/services/microsoft/macs/tenants/${tenantId}/365-licenses/${userPrincipalName}`,
        microsoft365UserLicenses,
      )
      .pipe(
        tap(() => {
          this._stateSource.next(microsoft365UserLicenses);
        }),
      );
  }
}
